import Vue from 'vue'
import Vuex from 'vuex'

// ajde instaliraj ovaj vuex - npm install vuex
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        expressions: [],
        expressions1: [],
    },
    mutations: {
        setExpressions(state, expressions) {
            state.expressions = expressions;
        },
        setExpressions1(state, expressions1) {
            state.expressions1 = expressions1;
        },
    }
})